// Category Strip Accordion
function categoryAccordion(viewMoreText = 'View More', viewLessText = 'View Less') {
  const categoryContainer = document.querySelector('.category-strip__container');
  if (categoryContainer) {
    const categoryButton = document.querySelector('.category-strip__button');
    categoryButton.innerText = viewMoreText;
    categoryButton.addEventListener('click', function() {
      this.classList.toggle('category-strip__button--active');
      categoryContainer.classList.toggle('category-strip__container--expanded');
      if (this.classList.contains('category-strip__button--active')){
        this.innerText = viewLessText;
      } else {
        this.innerText = viewMoreText;
      }
    });
  }
};

// module.exports = categoryAccordion;
export { categoryAccordion };